import {
	Component,
	OnInit,
	Inject,
	ViewChildren,
	QueryList,
	ChangeDetectorRef,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DashboardPorletsService } from "../../dashboardPorlets.service";
import { HttpClient } from "@angular/common/http";
import { ApiList } from "../../api";
import {
	ExcelExportProperties,
	ColumnModel,
} from "@syncfusion/ej2-angular-grids";
import { IAxisSet } from "@syncfusion/ej2-angular-pivotview";
import { find } from "lodash";

import { GadgetTableComponent } from "../../gadget-group/gadget-table/gadget-table.component";
import { GadgetPivotChartComponent } from "../../gadget-group/gadget-pivot-chart/gadget-pivot.component";
import { GadgetPivotComponent } from "../../gadget-group/gadget-pivot/gadget-pivot.component";
import { BarChartsComponent } from "../../bar-charts/bar-charts.component";
import { getTranslation } from "../../../utils/utils";

@Component({
	selector: "rs-pane-download",
	templateUrl: "./index.component.html",
	styleUrls: ["./index.component.scss"],
})
export class PaneDownloadComponent implements OnInit {
	translation;
	@ViewChildren("dtable")
	public table: QueryList<GadgetTableComponent>;
	@ViewChildren("dpivot")
	public pivot: QueryList<GadgetPivotComponent | GadgetPivotChartComponent>;
	@ViewChildren("dnewChart") newChart: QueryList<BarChartsComponent>;
	portlets = [];

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any = {
			portlets: [],
			dashboard: null,
		},
		public dialogRef: MatDialogRef<PaneDownloadComponent>,
		private DashboardPorletsService: DashboardPorletsService,
		private httpClient: HttpClient,
		private api: ApiList,
		private ref: ChangeDetectorRef
	) {}

	ngOnInit() {
		this.translation = getTranslation();
		this.portlets = this.data.portlets.filter((item) => {
			const type = this.getPortletType(item);
			return type !== "transpose";
		});
	}

	close() {
		this.dialogRef.close();
	}

	async downloadAll() {
		for (let portlet of this.portlets) {
			await this.download(portlet);
		}
		setTimeout(() => {
			this.close();
		}, 200);
	}

	GetgadgetTitle(config) {
		if (config && config !== "null") {
			let config_ = JSON.parse(config);
			return config_.gadgetTitle;
		} else {
			return "";
		}
	}

	async download(item) {
		return new Promise(async (resolve) => {
			const portletType = this.getPortletType(item);
			const title = this.GetgadgetTitle(item.config);
			switch (portletType) {
				case "table":
					await this.downloadTable(item, title);
					break;
				case "newchart":
				case "pivot":
					const pivot = find(
						(this.pivot as any)._results,
						(el) => el.portlet.newId === item.newId
					);
					const excelExportProperties_pivot: ExcelExportProperties = {
						fileName: title
							? title + ".xlsx"
							: "Pivot-" + new Date().toISOString() + ".xlsx",
					};
					if (pivot.pivotObj.dataSourceSettings.formatSettings) {
						pivot.pivotObj.dataSourceSettings.formatSettings.forEach(
							(setting) => {
								// syncfusion format transform to excel format
								const map = {
									"#,###,,.0;(#,###,,.0)": '0.0,,"";(0.0,,)',
									'0.0,,"";(0.0,,)': "#,###,,.0;(#,###,,.0)",
									"#,###,,;(#,###,,)": '0,,"";(0,,)',
									'0,,"";(0,,)': "#,###,,;(#,###,,)",
									"#,###,,.00;(#,###,,.00)":
										'0.00,,"";(0.00,,)',
									'0.00,,"";(0.00,,)':
										"#,###,,.00;(#,###,,.00)",
								};

								if (map[setting.format]) {
									setting.format = map[setting.format];
									setTimeout(() => {
										setting.format = map[setting.format];
										this.ref.markForCheck();
										this.ref.detectChanges();
									});
								}
							}
						);
					}
					this.updateFormat(
						pivot.pivotObj.grid.columns as ColumnModel[],
						pivot.pivotObj
					);
					pivot.pivotObj.excelExport(excelExportProperties_pivot);
					break;
				case "newcolumn":
				case "newline":
				case "newcolumnline":
					const chartIdx = this.getChartIndexInAll(item);
					const selectedComponent = this.newChart.toArray()[chartIdx];
					selectedComponent.exportChart();
					break;
			}
			resolve(true);
		});
	}

	// 根据idx获取点击图表在图表列表里的真正顺序
	getChartIndexInAll(item) {
		const charArr = this.portlets.filter((e) => {
			return ["newcolumn", "newline", "newcolumnline"].includes(
				JSON.parse(e.config).portletType
			);
		});
		let resultIdx = 0;
		if (charArr.length > 0) {
			charArr.forEach((e, idx) => {
				if (e.newId == item.newId) {
					resultIdx = idx;
				}
			});
		}
		return resultIdx;
	}

	public downloadTable(item, title) {
		// Table 下载全部数据
		let config = JSON.parse(item.config);
		let pageSetting = Object.assign(
			{
				currentPage: 1,
				pageSize: 9999999,
			},
			config && config.tableSortSetting
		);
		let params = this.DashboardPorletsService.getParamsByPortlet(
			item,
			pageSetting
		);
		return new Promise((resolve) => {
			// json buffer
			this.httpClient
				.post(
					this.api.baseurl + this.api.urlList.GetPortletDataV2,
					params
				)
				.subscribe(
					(result) => {
						if (result) {
							const table = find(
								(this.table as any)._results,
								(el) => el.portlet.newId === item.newId
							);
							const excelExportProperties: ExcelExportProperties =
								{
									fileName: title
										? title + ".xlsx"
										: "Table-" +
										  new Date().toISOString() +
										  ".xlsx",
									// @ts-ignore
									dataSource: result.data,
								};
							if (table) {
								table.grid.excelExport(excelExportProperties);
							}
						}
						resolve(true);
					},
					(response) => {},
					() => {}
				);
		});
	}

	private updateFormat(columns: ColumnModel[], pivotObj) {
		var fList = pivotObj.renderModule.getFormatList();
		for (var i = 0; i < columns.length; i++) {
			if (
				(columns[i] as ColumnModel).columns &&
				(columns[i] as ColumnModel).columns.length > 0
			) {
				this.updateFormat(
					(columns[i] as ColumnModel).columns as ColumnModel[],
					pivotObj
				);
			} else {
				if (
					columns[i].customAttributes &&
					fList[
						(columns[i].customAttributes.cell as IAxisSet)
							.actualText
					] === "N"
				) {
					(columns[i] as ColumnModel).format = undefined;
				}
			}
		}
	}

	public getPortletType(item) {
		const config = item && item.config ? JSON.parse(item.config) : {};
		if (config.portletType) {
			if (config.portletType === "historicalIRR") {
				return config.selectedVisualType;
			}
			return config.portletType;
		}
	}

	updatePorletConfig(event) {
		// 处理配置更新
		console.log('updatePorletConfig called with:', event);
	}
}
